module.exports = __webpack_public_path__ + "img/1f96c.d6529b3.svg";